let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jSeDh")).then(() => parcelRequire('1VFmu'));